import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M12 3a9.75 9.75 0 0 1 6.74 2.74', key: '1k3kxf' }],
  ['path', { d: 'M18.74 5.74 21 8', key: '1eb40o' }],
  ['path', { d: 'M21 8V3', key: '1et280' }],
  ['path', { d: 'M7.5 19.794c-6-3.464-6-12.124 0-15.588', key: '19r0lp' }],
  ['path', { d: 'M7.5 4.206A9 9 0 0 1 12 3', key: 's8r11' }],
  ['path', { d: 'M12 7v5l4 2', key: '1fdv2h' }],
  ['path', { d: 'M14 20.775A9 9 0 0 1 12 21', key: '184rgu' }],
  ['path', { d: 'M19 17.656a9 9 0 0 1-1.5 1.456', key: '7qgp6l' }],
  ['path', { d: 'M21 12a9 9 0 0 1-.228 2', key: '1h378y' }],
  ['path', { d: 'M21 8h-5', key: 'k0yzmk' }],
];

/**
 * @component @name RotateCwFadingClock
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgM2E5Ljc1IDkuNzUgMCAwIDEgNi43NCAyLjc0IiAvPgogIDxwYXRoIGQ9Ik0xOC43NCA1Ljc0IDIxIDgiIC8+CiAgPHBhdGggZD0iTTIxIDhWMyIgLz4KICA8cGF0aCBkPSJNNy41IDE5Ljc5NGMtNi0zLjQ2NC02LTEyLjEyNCAwLTE1LjU4OCIgLz4KICA8cGF0aCBkPSJNNy41IDQuMjA2QTkgOSAwIDAgMSAxMiAzIiAvPgogIDxwYXRoIGQ9Ik0xMiA3djVsNCAyIiAvPgogIDxwYXRoIGQ9Ik0xNCAyMC43NzVBOSA5IDAgMCAxIDEyIDIxIiAvPgogIDxwYXRoIGQ9Ik0xOSAxNy42NTZhOSA5IDAgMCAxLTEuNSAxLjQ1NiIgLz4KICA8cGF0aCBkPSJNMjEgMTJhOSA5IDAgMCAxLS4yMjggMiIgLz4KICA8cGF0aCBkPSJNMjEgOGgtNSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/rotate-cw-fading-clock
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RotateCwFadingClock = createLucideIcon('rotate-cw-fading-clock', __iconNode);

export default RotateCwFadingClock;
